module.exports = [{
      plugin: require('D:/backup/documentos otros/Smartempo/stpo-gatsby-site/node_modules/gatsby-plugin-google-analytics/gatsby-browser.js'),
      options: {"plugins":[],"trackingId":"UA-138685017-1"},
    },{
      plugin: require('D:/backup/documentos otros/Smartempo/stpo-gatsby-site/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
